export class Workbook {
  SheetNames: Array<string> = [];
  Sheets: any = {};
}
